import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { iconButtonPropTypes } from './IconButton.types';
import { Ripple } from '../Ripple';
import { enhanceWithTrackable } from '../hocs';
import { IconButtonSkin } from './skins';

var IconButton = function IconButton(_a) {
  var color = _a.color,
      disabled = _a.disabled,
      Icon = _a.icon,
      rest = __rest(_a, ["color", "disabled", "icon"]);

  return React.createElement(Ripple, {
    disabled: disabled,
    center: true,
    color: color,
    render: function render(_ref) {
      var onBlur = _ref.onBlur,
          onFocus = _ref.onFocus,
          onKeyDown = _ref.onKeyDown,
          onMouseDown = _ref.onMouseDown,
          onMouseLeave = _ref.onMouseLeave,
          onMouseUp = _ref.onMouseUp,
          onTouchEnd = _ref.onTouchEnd,
          onTouchMove = _ref.onTouchMove,
          onTouchStart = _ref.onTouchStart;
      return React.createElement(IconButtonSkin, _extends({}, rest, {
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart,
        disabled: disabled
      }), React.createElement(Icon, {
        color: color,
        disabled: disabled,
        size: 24
      }));
    }
  });
};

IconButton.propTypes = iconButtonPropTypes;
IconButton.displayName = 'iconButton';
IconButton.defaultProps = {
  accessibilityExpanded: false,
  accessibilityHaspopup: false,
  accessibilityLabel: '',
  disabled: false,
  autoFocus: false,
  color: 'lightOrange'
};
var TrackableIconButton = enhanceWithTrackable(IconButton);
export { TrackableIconButton as IconButton };